module.exports = __webpack_public_path__ + "img/banner2_9_kr.7781ef0d.png";